import React, { useEffect } from "react";
import ContentLoader from "react-content-loader";
import {
  MESSAGE_TYPE,
  PRODUCT_BULLION_TYPE,
  PRODUCT_GOLD_TYPE_NAME_INITIAL,
  USER_DASHBOARD_BULLION,
} from "../../../../constants";
import { useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { updateUserDashboardAction } from "../../../../actions/userDashboard";
import CurrencyFormat from "../../../../components/currencyFormat/currencyFormat";
import { RoutesPaths } from "../../../../Router/constant";
import { useNavigate } from "react-router";
import { companyLink } from "../../../../components/ContactUs/ContactUs";

export default function BullionBalance({
  isEditing,
  setIsEditing,
  sendMessageToAdmin,
  adminLoader,
}) {
  const { control, reset, register, handleSubmit } = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isUserDashboardBullionBalanceLoading } = useSelector(
    (state) => state.userDashboard
  );
  const { metalAllocation } = useSelector((state) => state.userDashboard);
  const { selectedCompany } = useSelector((state) => state.company);

  const { isAdminLoggedIn } = useSelector((state) => state.auth);
  const { bidGoldHeader, bidSilverHeader } = useSelector((state) => state.user);
  const { fields, append, remove } = useFieldArray({
    control,
    name: "metalAllocation",
  });

  useEffect(() => {
    const getBullionBalance = () => {
      reset();
      metalAllocation &&
        metalAllocation?.length > 0 &&
        metalAllocation.forEach((element) => {
          append({
            type: element?.type,
            currency: element?.currency,
            bullion: element?.product?.length > 0 ? element?.product?.map(x => x.name) : element?.productName,
            weight: element?.metal,
            balance: element?.balance,
            convertionCurrency: element?.convertionCurrency,
            convertionBalance: element?.convertionBalance,
            bullionType: parseInt(element?.bullionType),
            quantity: parseInt(element?.quantity)
          });
        });
    };
    getBullionBalance();
  }, [metalAllocation]);

  const onSubmit = async (data) => {
    await dispatch(updateUserDashboardAction(data));
    setIsEditing(null);
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="accountBorderSection">
          {isUserDashboardBullionBalanceLoading ? (
            <div className="row cashHederSection cashHederSectionPadding">
              <div className="col-md-12">
                <div style={{ width: "100%", marginLeft: "auto" }}>
                  <ContentLoader width="100%" height={15}>
                    <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
                  </ContentLoader>
                </div>
              </div>
            </div>
          ) : (
            <div className="row cashHederSection cashHederSectionPadding">
              <div className="col-md-5 col-6 button_align">
                <h6 className="cashHeaderText cashDarkText m-0">Bullion</h6>
              </div>
              {isAdminLoggedIn && (
                <div className="col-md-7 col-6 flexSection mobileAlign">
                  <span className="btn btn-link  px-3 mb-0 edit-button faded-edit iconMarginLeft"></span>
                </div>
              )}
            </div>
          )}

          <div className="col-12">
            <hr className="m-0"></hr>
          </div>

          <div className="cashBottomPadding">
            <div className="row">
              <div className="col-5">
                <p className="accountPrimaryText">Product name</p>
              </div>
              <div
                className={`col-2 text-center`}>
                <p className="accountPrimaryText">Weight</p>
              </div>
              <div
                className={`col-5 rightAlignText`}>
                <p className="accountPrimaryText">Value</p>
              </div>
              {isEditing === USER_DASHBOARD_BULLION.BULLIONBALANCE ? (
                <div className="col-2 deleteIcon">
                  <p className="accountPrimaryText">Action</p>
                </div>
              ) : (
                <></>
              )}
            </div>

            {isUserDashboardBullionBalanceLoading ? (
              <div className="row">
                <div className="col-12 currentBalanceDetails">
                  <ContentLoader width="100%" height={15}>
                    <rect x="0" y="0" rx="5" ry="5" width="100%" height="15" />
                  </ContentLoader>
                </div>
              </div>
            ) : (
              fields?.map((record, index) => (
                <div key={record.id} className="row">
                  <div className="col-5">
                    {isEditing === USER_DASHBOARD_BULLION.BULLIONBALANCE ? (
                      <input
                        type="text"
                        className="form-control customInputField mb-2"
                        {...register(`bullionRecord.${index}.bullion`)}
                      />
                    ) : (
                      <h6 className="accountSecondaryText">
                        {record?.bullion?.join(", ") || "-"}
                      </h6>
                    )}
                  </div>

                  <div className={`col-2 text-center`}>
                    {isEditing === USER_DASHBOARD_BULLION.BULLIONBALANCE ? (
                      <input
                        type="text"
                        className="form-control customInputField mb-2"
                        {...register(`bullionRecord.${index}.weight`)}
                      />
                    ) : (
                      <h6 className="accountSecondaryText">
                        {record?.weight || "-"}{" "}
                        {record?.type ===
                          PRODUCT_GOLD_TYPE_NAME_INITIAL.HEDGEKILOGRAM
                          ? PRODUCT_GOLD_TYPE_NAME_INITIAL.KILOGRAM
                          : record?.type === PRODUCT_GOLD_TYPE_NAME_INITIAL.GRAM ? "gram" : record?.type || "-"}
                      </h6>
                    )}
                  </div>
                  <div className={`col-5 rightAlignText`}>
                    {isEditing === USER_DASHBOARD_BULLION.BULLIONBALANCE ? (
                      <input
                        type="text"
                        className="form-control customInputField mb-2 textInputAlignText"
                        {...register(`bullionRecord.${index}.balance`)}
                      />
                    ) : (
                      <h6 className="accountSecondaryText">
                        {record?.type === PRODUCT_GOLD_TYPE_NAME_INITIAL.KILOGRAM ? (
                          <>
                            {record?.convertionCurrency?.toUpperCase()}{" "}
                            {record?.bullionType === PRODUCT_BULLION_TYPE.GOLD ?
                              <CurrencyFormat
                                currency={record?.convertionCurrency}
                                value={parseFloat((bidGoldHeader?.gold1kg?.price * record?.quantity))}
                                decimal={2}
                              />
                              :
                              <CurrencyFormat
                                currency={record?.convertionCurrency}
                                value={parseFloat((bidSilverHeader?.silver1kg?.price * record?.quantity))}
                                decimal={2}
                              />
                            }
                          </>
                        ) : record?.type === PRODUCT_GOLD_TYPE_NAME_INITIAL.GRAM ? (
                          <>
                            {record?.convertionCurrency?.toUpperCase()}{" "}
                            {record?.bullionType === PRODUCT_BULLION_TYPE.GOLD ?
                              <CurrencyFormat
                                currency={record?.convertionCurrency}
                                value={parseFloat((bidGoldHeader?.gold1g?.price * record?.quantity))}
                                decimal={2}
                              />
                              :
                              <CurrencyFormat
                                currency={record?.convertionCurrency}
                                value={parseFloat((bidSilverHeader?.silver10g?.price * record?.quantity))}
                                decimal={2}
                              />
                            }
                          </>
                        ) : record?.type ===
                          PRODUCT_GOLD_TYPE_NAME_INITIAL.HEDGEKILOGRAM ? (
                          <>
                            {record?.convertionCurrency?.toUpperCase()}{" "}
                            <CurrencyFormat
                              currency={record?.convertionCurrency}
                              value={parseFloat(
                                bidGoldHeader?.gold1kghedge?.price * record?.quantity
                              )}
                              decimal={2}
                            />
                          </>
                        ) : record?.type ===
                          PRODUCT_GOLD_TYPE_NAME_INITIAL.OUNCE ? (
                          <>
                            {record?.convertionCurrency?.toUpperCase()}{" "}
                            <CurrencyFormat
                              currency={record?.convertionCurrency}
                              value={parseFloat(
                                bidGoldHeader?.gold1ounce?.price * record?.quantity
                              )}
                              decimal={2}
                            />
                          </>
                        ) : (
                          <>
                            {record?.convertionCurrency?.toUpperCase()}{" "}
                            <CurrencyFormat
                              currency={record?.convertionCurrency}
                              value={parseFloat(record?.convertionBalance)}
                              decimal={2}
                            />
                          </>
                        )}
                      </h6>
                    )}
                  </div>
                  {isEditing === USER_DASHBOARD_BULLION.BULLIONBALANCE ? (
                    <div className="col-2 deleteIcon">
                      <div
                        onClick={() => {
                          remove(index);
                        }}>
                        <span className="mb-0">
                          <i className="fa fa-times-circle edit-button m-0"></i>
                        </span>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              ))
            )}

            {isEditing === USER_DASHBOARD_BULLION.BULLIONBALANCE ? (
              <div className="row">
                <div className="col-12 addRowAlignIcon addRightPadding">
                  <span
                    className="btn btn-link px-3 mb-0 edit-button"
                    onClick={() => {
                      append({ bullion: "", weight: "", balance: "" });
                    }}>
                    <i className="fa-solid fa-plus edit-button"></i>
                  </span>
                </div>
              </div>
            ) : (
              <></>
            )}

            {isUserDashboardBullionBalanceLoading ? (
              <div className="row cashBottomButton">
                <div className="col-7 skeletonFlexBB">
                  <ContentLoader width="85%" height={50}>
                    <rect x="0" y="0" rx="10" ry="10" width="85%" height="40" />
                  </ContentLoader>

                  <ContentLoader width="85%" height={50}>
                    <rect x="0" y="0" rx="10" ry="10" width="85%" height="40" />
                  </ContentLoader>
                </div>
                <div className="col-5 skeletonFlexEnd">
                  <div style={{ width: "80%", marginLeft: "auto" }}>
                    <ContentLoader width="100%" height={50}>
                      <rect
                        x="0"
                        y="0"
                        rx="10"
                        ry="10"
                        width="100%"
                        height="40"
                      />
                    </ContentLoader>
                  </div>
                </div>
              </div>
            ) : (
              <div className="row cashBottomButton">
                <div className="col-7 button_align">
                  <button
                    disabled={
                      adminLoader === 3 || adminLoader > 0 ? true : false
                    }
                    type="button"
                    // onClick={() =>
                    //   sendMessageToAdmin(
                    //     MESSAGE_TYPE.USER_DASHBOARD,
                    //     "<strong>Buy Bullion</strong>: I am interested to procure bullion",
                    //     3
                    //   )
                    // }
                    onClick={() => navigate(RoutesPaths.PRODUCTS_LIST_PAGE)}
                    className="customFilterButton mobileViewImportButton buttonRIghtMargin spotlightStep1">
                    {adminLoader === 3 && (
                      <i className="animateSpin fa-solid fa-circle-notch"></i>
                    )}{" "}
                    Buy bullion
                  </button>
                </div>
                {selectedCompany?.isWithdraw &&
                  <div className="col-5 rightAlignText">
                    <button
                      disabled={
                        adminLoader === 4 || adminLoader > 0 ? true : false
                      }
                      type="button"
                      onClick={() => sendMessageToAdmin(MESSAGE_TYPE.USER_DASHBOARD, `<strong>Ship bullion</strong>: I am interested to ship bullion under ${companyLink(selectedCompany)} account`, 4)}
                      className="customImportButton mobileViewImportButton m-0">
                      {adminLoader === 4 && (
                        <i className="animateSpin fa-solid fa-circle-notch"></i>
                      )}{" "}
                      Ship bullion
                    </button>
                    {/* <button
                    disabled={
                      adminLoader === 5 || adminLoader > 0 ? true : false
                    }
                    type="button"
                    onClick={() =>
                      sendMessageToAdmin(
                        MESSAGE_TYPE.USER_DASHBOARD,
                        "<strong>Withdraw funds</strong>: I am interested to withdraw funds",
                        5
                      )
                    }
                    className="customFilterButton mobileViewImportButton">
                    {adminLoader === 5 && (
                      <i className="animateSpin fa-solid fa-circle-notch"></i>
                    )}{" "}
                    Withdraw funds
                  </button> */}
                  </div>
                }
              </div>
            )}
          </div>
        </div>
      </form >
    </>
  );
}
